import { actions } from  '../constants';
import store from '../store';
import { remoteCall } from '../lib';
import { Map } from 'immutable';

function sendingEmail() {
  return {
    type: actions.EMAIL_ACCESS_CODE_REQUESTED,
    payload: {}
  };
}

function emailSent(invite) {
  return {
    type: actions.EMAIL_ACCESS_CODE_SENT,
    payload: {
      invite
    }
  };
}

function emailFailed() {
  return {
    type: actions.EMAIL_ACCESS_CODE_FAILED,
    payload: {}
  };
}

function sendingSms() {
  return {
    type: actions.SMS_ACCESS_CODE_REQUESTED,
    payload: {}
  };
}

function smsSent(invite) {
  return {
    type: actions.SMS_ACCESS_CODE_SENT,
    payload: {
      invite
    }
  };
}

function smsFailed() {
  return {
    type: actions.SMS_ACCESS_CODE_FAILED,
    payload: {}
  };
}

export function sendEmail(emailAddress, firstName, lastName){
  const postInvite = {
    invite: {
      emailAddress,
      firstName,
      lastName
    }
  };
  return (dispatch) => {
    dispatch(sendingEmail());
    remoteCall('patientInvites', 'invite', 'post', postInvite).then((invite) =>{      
      dispatch(emailSent(
        Map({
          firstName: postInvite.firstName,
          lastName: postInvite.lastName,
          invite: invite
        })
      ));
    }).catch((err) => {
      console.warn('Send email invite failed: ', err);
      dispatch(emailFailed(err));
    });
  };
}

export function sendSms(phoneNumber, firstName, lastName){
  const postInvite = {
    invite: {
      phoneNumber,
      firstName,
      lastName
    }
  };
  return (dispatch) => {
    dispatch(sendingSms());
    remoteCall('patientInvites', 'invite', 'post', postInvite).then((invite) =>{      
      dispatch(smsSent(
        Map({
          firstName: postInvite.firstName,
          lastName: postInvite.lastName,
          invite: invite
        })
      ));
    }).catch((err) => {
      console.warn('Send sms invite failed: ', err);
      dispatch(smsFailed(err));
    });
  };
}

export function createNewPatient() {
  return {
    type: actions.RESET_NEW_PATIENT,
    payload: {}
  };
}



// WEBPACK FOOTER //
// ./src/actions/add-patient.js